module.exports = __webpack_public_path__ + "static/img/btor-95mid.3c5e131.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/btor-95mid.jpg
// module id = cxBy
// module chunks = 0